import { ONE } from 'config/apis'
import { getCachedRequest } from 'utils/cache'

const doFetch = async ({ id = '', endpoint, queryString = '' }) => {
  try {
    const req = await fetch(
      `${ONE[endpoint].replace('{id}', id)}${queryString}`,
      { ...ONE.HEADERS }
    )
    const parsed = await req.json()
    return parsed?.Data || parsed
  } catch (err) {
    console.log(err)
  }
}

export async function publicGetRequest(params) {
  const key = `${params.id}-${params.endpoint}`
  return getCachedRequest(key, () => doFetch(params))
}
